import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocalizedTextService } from '../../core';

@Pipe({
  name: 'localizedText',
  pure: true,
})
export class LocalizedTextPipe implements PipeTransform {
  private readonly localizedTextService = inject(LocalizedTextService);

  transform(english?: string | null, french?: string | null): string {
    return this.localizedTextService.getLocalizedText(english, french);
  }
}
